// Carry Roll Gapping engine — full-bag carry/total gapping (6.3–6.6). Pure functions.
import { ClubCategory } from './types';
const OVERLAP_THRESHOLD_M = 3;
const HOLE_THRESHOLD_M = 22;
/** Build a gapping chart from bag entries, flagging overlaps and holes (6.6). */
export function buildBag(entries) {
    const sorted = [...entries].sort((a, b) => b.carryM - a.carryM);
    const issues = [];
    for (let i = 0; i < sorted.length - 1; i++) {
        const a = sorted[i];
        const b = sorted[i + 1];
        const gap = a.carryM - b.carryM;
        if (gap < -OVERLAP_THRESHOLD_M) {
            issues.push({
                type: 'overlap',
                clubA: a.clubName,
                clubB: b.clubName,
                gapM: gap,
                message: `${a.clubName} and ${b.clubName} overlap by ${Math.abs(Math.round(gap))} m — consider adjusting lofts.`,
            });
        }
        else if (gap > HOLE_THRESHOLD_M) {
            issues.push({
                type: 'hole',
                clubA: a.clubName,
                clubB: b.clubName,
                gapM: gap,
                message: `${Math.round(gap)} m gap between ${a.clubName} and ${b.clubName} — consider adding a club.`,
            });
        }
    }
    return { entries: sorted, issues };
}
const SPEED_PROGRESSION = [
    { category: ClubCategory.Wood, loftDeg: 15, carryFraction: 0.9 },
    { category: ClubCategory.Wood, loftDeg: 18, carryFraction: 0.84 },
    { category: ClubCategory.Hybrid, loftDeg: 21, carryFraction: 0.78 },
    { category: ClubCategory.Iron, loftDeg: 24, carryFraction: 0.73 },
    { category: ClubCategory.Iron, loftDeg: 27, carryFraction: 0.68 },
    { category: ClubCategory.Iron, loftDeg: 31, carryFraction: 0.63 },
    { category: ClubCategory.Iron, loftDeg: 35, carryFraction: 0.58 },
    { category: ClubCategory.Iron, loftDeg: 39, carryFraction: 0.53 },
    { category: ClubCategory.Iron, loftDeg: 43, carryFraction: 0.48 },
    { category: ClubCategory.Wedge, loftDeg: 47, carryFraction: 0.43 },
    { category: ClubCategory.Wedge, loftDeg: 52, carryFraction: 0.38 },
    { category: ClubCategory.Wedge, loftDeg: 56, carryFraction: 0.33 },
];
/** Estimate unmeasured clubs from a known driver carry (6.4), flagged `estimated`. */
export function estimateUnmeasured(driverCarry) {
    return SPEED_PROGRESSION.map((p, i) => ({
        clubName: `Est-${i + 1}`,
        category: p.category,
        loftDeg: p.loftDeg,
        carryM: driverCarry * p.carryFraction,
        totalM: driverCarry * p.carryFraction * 1.1,
        estimated: true,
    }));
}
export function rollPercentByCategory(category) {
    const map = {
        [ClubCategory.Driver]: 0.2,
        [ClubCategory.Wood]: 0.15,
        [ClubCategory.Hybrid]: 0.12,
        [ClubCategory.Iron]: 0.08,
        [ClubCategory.Wedge]: 0.03,
    };
    return map[category] ?? 0.1;
}
//# sourceMappingURL=gapping.js.map